<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: SwbOrienteeringCallBidListPath }">定向招标市场</el-breadcrumb-item>
                <el-breadcrumb-item>招标报名</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <div class="bidding-enroll">
            <div class="bidding-info">
                <div class="content-caption dashed">
                    <span><span class="color-laber"></span>招标信息</span>
                </div>
                <div class="info">
                    <ul class="info-list">
                        <li class="info-item" style="width: 25%">
                            <span>标书名称：</span>
                            <a class="mr10">{{callBidDocInfo.title}}</a>
                        </li>
                        <li class="info-item" style="width: 25%">
                            <span>报名截止时间：</span>
                            <span>{{callBidDocInfo.enrollCloseTime}}</span>
                        </li>
                        <li class="info-item" style="width: 25%">
                            <span>报名费用：</span>
                            <span v-if="callBidDocInfo.enrollFree">免费</span>
                            <span v-else>{{callBidDocInfo.enrollFee}}元</span>
                        </li>
                    </ul>
                </div>
            </div>

            <el-form :model="bidEnrollInfo" ref="ruleForm" class="demo-ruleForm" :rules="rules"> <!--:rules="ruleForm"-->
                <div class="enroll-info">
                    <div class="content-caption dashed">
                        <span><span class="color-laber"></span>报名信息</span>
                    </div>
                    <div class="form-info">
                        <div class="form-row">
                            <div class="form-label">
                                <label class="required">联系人：</label>
                            </div>
                            <div class="form-value width-1-5x">
                                <el-form-item prop="contactName">
                                    <el-input v-model="bidEnrollInfo.contactName"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-label">
                                <label class="required">联系电话：</label>
                            </div>
                            <div class="form-value width-1-5x">
                                <el-form-item prop="contactTel">
                                    <el-input v-model="bidEnrollInfo.contactTel"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-label">
                                <label>联系邮箱：</label>
                            </div>
                            <div class="form-value width-1-5x">
                                <el-form-item prop="contactEmail">
                                    <el-input v-model="bidEnrollInfo.contactEmail"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>

            <!-- 资质信息 -->
            <div class="content-caption dashed">
                <span><span class="color-laber"></span>资质信息</span>
            </div>
            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th>招标资质组号</th>
                    <th>招标资质名称</th>
                    <th>招标资质类型</th>
                    <th>是否必须</th>
                    <th width="180">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="merchantQuali in merchantQualiList">
                    <td>
                        <span>{{merchantQuali.groupNo}}</span>
                    </td>
                    <td :class="{ selected : merchantQuali.qualiId != null}">
                        <span>{{merchantQuali.callQualiTypeName}}</span>
                    </td>
                    <td>
                        <span>{{qualiKindList[merchantQuali.callQualiKind].text}}</span>
                    </td>
                    <td>
                        <div class="table-addr">
                            <el-radio-group disabled v-model="merchantQuali.callMandatory">
                                <el-radio :label=false>否</el-radio>
                                <el-radio :label=true>是</el-radio>
                            </el-radio-group>
                        </div>
                    </td>
                    <td>
                        <a class="swb-btn-link" @click="showMerchantQualiDialog(merchantQuali.callQualiTypeId)">选择</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="content-caption dashed">
                <span><span class="color-laber"></span>要求的人员资质</span>
            </div>
            <table class="custom-tbl">
                <thead class="head align-left">
                <tr class="row">
                    <th>资质类型</th>
                    <th>类型名称</th>
                    <th>类型等级（及以上）</th>
                    <th>是否必须</th>
                    <th>要求数量</th>
                    <th>资质数量</th>
                </tr>
                </thead>
                <tbody class="body align-left">
                <tr class="row" v-for="staffQuali in callBidDocInfo.staffQualiList">
                    <td class="align-left">{{staffQuali.name}}</td>
                    <td class="align-left">{{staffQuali.qualiName}}</td>
                    <td>
                        <div class="table-addr">
                            <span v-if="staffQuali.qualiLevel == 1">一级</span>
                            <span v-if="staffQuali.qualiLevel == 2">二级</span>
                            <span v-if="staffQuali.qualiLevel == 3">三级</span>
                            <span v-if="staffQuali.qualiLevel == 4">四级</span>
                            <span v-if="staffQuali.qualiLevel == 5">五级</span>
                        </div>
                    </td>
                    <td>
                        <div class="table-addr">
                            <span v-if="staffQuali.mandatory">是</span>
                            <span v-else>否</span>
                        </div>
                    </td>
                    <td>{{staffQuali.quantity}}</td>
                    <td>
                        <span v-if="staffQuali.mandatory && staffQuali.quantity &gt; staffQuali.staffQualiQuantity" class="font-red">{{staffQuali.staffQualiQuantity}}</span>
                        <span v-if="!staffQuali.mandatory && staffQuali.quantity &gt; staffQuali.staffQualiQuantity" class="font-gold">{{staffQuali.staffQualiQuantity}}</span>
                        <span v-if="staffQuali.quantity &lt;= staffQuali.staffQualiQuantity">{{staffQuali.staffQualiQuantity}}</span>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="content-caption dashed">其他招标要求详见招标公告。</div>
            <!-- 上传附件 -->
            <div class="content-caption dashed">
                <span><span class="color-laber"></span>附件信息</span>
            </div>
            <div class="form-single mt20">
                <div class="title required" style="text-align: left">上传附件</div>
                <div class="content" style="padding-left: 38px;">

                    <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                    <div class="file-area clearfix">
                        <swb-file-item v-for="(enrollfile, index) in enrollFiles" :trackKey="index" :fileName="enrollfile.name" :fileBrowseUrl="enrollfile.fileBrowseUrl" :fileUuid="enrollfile.fileUuid" :fileDownloadUrl="enrollfile.fileDownloadUrl" :fileMd5="enrollfile.fileMd5" :deletable="true" :onDelete="removeUpload"></swb-file-item>
                    </div>
                </div>
            </div>

            <div class="hint block mt20 mb20">
                <el-checkbox v-model="agreeFlag">
                    <p class="inline-block">我司承诺所提供材料按招标公告要求提供，并且真实有效</p>
                </el-checkbox>
            </div>
        </div>
        <div v-if="merchantTypeMatches" class="form-toolbar align-center mt30" style="padding: 0;">
            <button class="swb-btn mr20" @click="goBackEnroll">取消</button> <!-- true 是否保存 -->
            <button class="swb-btn mr20" @click="saveBidEnrollInfo()">保存</button> <!-- true 是否保存 -->
        </div>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import userApi from '../../api/user'
    import callBidApi from '../../api/callBid'
    import tendBidApi from '../../api/tendBid'

    import SwbMerchantQualiForSelect from '../quali/MerchantQualiForSelect';
    Vue.regist(SwbMerchantQualiForSelect);

    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    import SwbBidEnrollList from './BidEnrollList';
    Routes.add(SwbBidEnrollList);

    import SwbOrienteeringCallBidList from './OrienteeringCallBidList';
    Vue.regist(SwbOrienteeringCallBidList);

    function sortCallBidReqQuali(itemList) {
        itemList.sort(function (item1, item2) {
            var retValue = item1['groupNo'] - item2['groupNo'];
            if(retValue == 0) {
                retValue = item1['seqNo'] - item2['seqNo']
            }
            return retValue;
        });
        return itemList;
    }

    export default{
        name: 'swb-bid-enroll-sign-up',
        path: '/tend/bid/enroll/save',
        pathOld: '/bid/enroll/signUp',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '投标报名保存',
        data: function () {
            let checkeName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('联系人不能为空'));
                } else {
                    callback();
                }
            };
            let checContactEmail = function (rule, value, callback) {
                if(!Utils.isNoB(value)) {
                    if(!Utils.isEmail(value)) {
                        callback(new Error('填写正确的邮箱'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let checkTel = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('联系电话不能为空'));
                }
                else if(!Utils.isPhoneNo(value)) {
                    callback(new Error('请填写正确的联系电话'));
                } else {
                    callback();
                }
            };
            return {
                callDocId: null,
                callBidDocInfo: {
                    title: null,
                    enrollCloseTime: null,
                    enrollFree: true,
                    enrollFee: null
                },
                //
                bidEnrollInfo: {},
                groupNoQualiIdsMap: {},
                qualiKindList: [],
                //
                merchantQualiList: [],
                enrollFiles: [],
                //
                agreeFlag: false, // 同意招投标公告！

                merchantTypeMatches: false,//判断是否可以投标,merchantType是否对应的上
                userInfo: null, //获取的当前用户信息

                rules: {
                    contactName: [
                        {validator: checkeName, trigger: 'blur'}
                    ],
                    contactTel: [
                        {validator: checkTel, trigger: 'blur'}
                    ],
                    contactEmail: [
                        {validator: checContactEmail, trigger: 'blur'}
                    ],
                },
                SwbOrienteeringCallBidListPath: ''

            }
        },
        created: function () {
            let self = this;
            self.callDocId = this.$route.query.callDocId;

            self.qualiKindList = getEnumList("qualiKind");

            let id = this.$route.query.id;
            if(id != null) {
                self.merchantTypeMatches = true;
                self.getBidEnrollInfo(id);
            } else {
                self.userCurrentInfo();
                self.getCallBidDocInfo();
            }
            //
            this.SwbOrienteeringCallBidListPath = SwbOrienteeringCallBidList.path;
        },
        methods: {
            goBackEnroll: function () {
                // console.log(this.$route.query.goindex);
                if(this.$route.query.goindex === 'true') {
                    this.$router.back(-1);
                } else {
                    // window.close();
                    this.$router.push({
                        path: SwbBidEnrollList.path,
                    });
                }
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let file = files[i];
                        let enrollFile = {};
                        enrollFile.name = file.fileName;
                        enrollFile.fileUuid = file.fileUuid;
                        enrollFile.fileExtName = file.fileExtName;
                        enrollFile.fileBrowseUrl = file.fileBrowseUrl;
                        enrollFile.fileDownloadUrl = file.fileDownloadUrl;
                        enrollFile.fileMd5 = file.fileMd5;
                        self.enrollFiles.push(enrollFile);
                    }
                } else {
                    this.$message.success(result.message);
                }
            },

            downloadDemoFile: function (fileDownloadUrl) {
                Utils.downloadFile(getAppUrl(fileDownloadUrl));
            },

            removeUpload: function (index) {
                this.enrollFiles.removeAt(index.trackKey);
                return false;
            },

            // 当前登录信息
            userCurrentInfo: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result) {
                    if(result.type === "info") {
                        self.userInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // 获取招标书信息
            getCallBidDocInfo: function () {
                let self = this;
                let callDocId = self.callDocId;
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidDocInfo(callDocId, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
//                        self.callBidDocInfo = result.data;
                        //
                        let callBidDocInfo = result.data;
                        //
                        let enrollCloseTime = callBidDocInfo.enrollCloseTime;
                        let serverDate = new Date().getTime();
                        enrollCloseTime = new Date(enrollCloseTime).getTime();
                        if(serverDate > enrollCloseTime) {
                            MsgBox.warning("报名已截至！", {callback: self.callBackHome, closeDelay: 3000});
                        }
                        self.callBidDocInfo = callBidDocInfo;
                        //
                        if(self.bidEnrollInfo.id == null) {
                            let curScopeEntity = self.userInfo.scopeEntity;
                            if(callBidDocInfo.reqMerchantType == curScopeEntity.type) {
                                self.merchantTypeMatches = true;
                            } else {
                                MsgBox.warning("您所属的商户类型与要求商户类型不匹配,不能报名!");
                            }
                            //生成资格列表
                            let callBidReqQualiList = self.callBidDocInfo.callBidReqQualiList || [];
                            let merchantQualiList = [];
                            for(let i = 0; i < callBidReqQualiList.length; i++) {
                                let callBidReqQuali = callBidReqQualiList[i];
                                let merchantQuali = {};
                                merchantQuali.callId = callBidReqQuali.id;
                                merchantQuali.callDocId = callBidReqQuali.docId;
                                merchantQuali.callQualiTypeId = callBidReqQuali.qualiTypeId;
                                merchantQuali.callQualiTypeName = callBidReqQuali.qualiTypeName;
                                merchantQuali.callQualiKind = callBidReqQuali.qualiKind;
                                merchantQuali.callMandatory = callBidReqQuali.mandatory;
                                merchantQuali.groupNo = callBidReqQuali.groupNo;
                                merchantQuali.qualiId = null;
                                //
                                merchantQualiList.add(merchantQuali);
                            }
                            //
                            if(merchantQualiList.length > 0) {
                                merchantQualiList = sortCallBidReqQuali(merchantQualiList);
                                self.syncGroupNo(merchantQualiList);
                            }
                            self.merchantQualiList = merchantQualiList;
                            //!!!关联 callDocId
                            self.bidEnrollInfo.callDocId = self.callBidDocInfo.id;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            callBackHome: function () {
                let pageRouteUrl = makePageRouteUrl(null, "/bench/home", null);
                Utils.setPageUrl(pageRouteUrl);
            },

            syncGroupNo: function (callBidReqQualiList) {
                let groupNoQualiIdsMap = {};
                for(let i = 0; i < callBidReqQualiList.length; i++) {
                    let callBidReqQuali = callBidReqQualiList[i];
                    let groupNo = callBidReqQuali.groupNo;
                    let callQualiTypeId = callBidReqQuali.callQualiTypeId;
                    let callQualiTypeIds = groupNoQualiIdsMap[groupNo];
                    if(callQualiTypeIds == null) {
                        callQualiTypeIds = [];
                        groupNoQualiIdsMap[groupNo] = callQualiTypeIds;
                    }
                    callQualiTypeIds.push(callQualiTypeId);
                }
                this.groupNoQualiIdsMap = groupNoQualiIdsMap;
            },

            //修改时使用，获取报名的信息
            getBidEnrollInfo: function (id) {
                let self = this;
                let theLoad = MsgBox.loading();
                tendBidApi.getBidEnrollInfo(id, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let bidEnrollInfo = result.data;
                        //
                        let merchantQualiList = bidEnrollInfo.bidEnrollQualiList || [];
                        if(merchantQualiList.length > 0) {
                            merchantQualiList = sortCallBidReqQuali(merchantQualiList);
                            self.syncGroupNo(merchantQualiList);
                        }
                        self.merchantQualiList = merchantQualiList;

                        delete  bidEnrollInfo['bidEnrollQualiList'];
                        //
                        self.enrollFiles = bidEnrollInfo.bidEnrollFileList || [];
                        delete  bidEnrollInfo['bidEnrollFileList'];
                        //
                        self.bidEnrollInfo = bidEnrollInfo;
                        //
                        self.callDocId = bidEnrollInfo.callDocId;
                        //
                        //获取招标书信息
                        self.getCallBidDocInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            lookNotice: function () {
                let self = this;
                Vue.$showDialog({
                    title: '查看 - 公告',
                    showCloseBtn: true,
                    width: 1200,
                    height: 900,
                    template: '<div>' +
                    '<swb-ck-editor ref="theCkEditor" :content="content"></swb-ck-editor>' +
                    '</div>',
                    data: {
                        content: null,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {
                        created: function () {
                            this.content = self.callBidDocInfo.callBidNotice.content;
                        }
                    }
                });
            },
            showMerchantQualiDialog: function (qualiTypeId) {
                let self = this;
                Vue.$showDialog({
                    title: "选择资质",
                    showCloseBtn: true,
                    width: 800,
                    height: 600,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-merchant-quali-for-select :qualiTypeId="qualiTypeId" ref="swb_have_merchant_quali"></swb-merchant-quali-for-select>' +
                    '</div>',
                    data: {
                        loading: false,
                        qualiTypeId: null
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_have_merchant_quali.getDlgResult() || {};
                        if(result !== null) {
                            if(result.type == 'info') {
                                let merchantQuali = result.merchantQuali;
                                if(merchantQuali != null) {
                                    let targetIndex = self.merchantQualiList.indexOf(qualiTypeId, function (quali, qualiTypeId) {
                                        return quali.callQualiTypeId == qualiTypeId;
                                    });
                                    let targetQuali = self.merchantQualiList[targetIndex];
                                    //
                                    targetQuali.qualiId = merchantQuali.id;
                                    self.$set(self.merchantQualiList, targetIndex, targetQuali);
                                }
                            } else {
                                MsgBox.warning(result.message);
                                return false;
                            }
                        } else {
                            MsgBox.warning('返回出错');
                            return false;
                        }
                    },
                    methods: {},
                    lifecycle: {
                        created: function () {
                            this.qualiTypeId = qualiTypeId;
                        }
                    }
                });
            },
            saveBidEnrollInfo: function (saveFalg) {
                let self = this;

                let bidEnrollInfo = Utils.merge({}, self.bidEnrollInfo);

                if(Utils.isNoB(bidEnrollInfo.contactTel)) {
                    Toast.show("联系电话不能为空", 3000, 'warning');
                    return false;
                } else {
                    if(!Utils.isPhoneNo(bidEnrollInfo.contactTel)) {
                        Toast.show("联系电话不正确", 3000, 'warning');
                        return false;
                    }
                }

                if(!Utils.isNoB(bidEnrollInfo.contactEmail)) {
                    if(!Utils.isEmail(bidEnrollInfo.contactEmail)) {
                        Toast.show("联系电子邮箱不正确", 3000, 'warning');
                        return false;
                    }
                }

                // 绑定 招标书id
                if(bidEnrollInfo.callDocId == null) {
                    bidEnrollInfo.callDocId = self.callBidDocInfo.id;
                }

                // 检查资质
                let merchantQualiList = self.merchantQualiList; // 拥有资质
                let merchantQualiMap = {};
                for(let k = 0; k < merchantQualiList.length; k++) {
                    let merchantQuali = merchantQualiList[k];
                    merchantQualiMap[merchantQuali.callQualiTypeId] = merchantQuali;
                }
                let grouNos = [];
                let groupNoQualiIdsMap = self.groupNoQualiIdsMap;
                for(let key in groupNoQualiIdsMap) {
                    grouNos.push(key);
                }
                for(let k = 0; k < grouNos.length; k++) {
                    let groupNo = grouNos[k];
                    let callQualiTypeIds = groupNoQualiIdsMap[groupNo];
                    if(callQualiTypeIds.length > 1) {
                        let mandatory = merchantQualiMap[callQualiTypeIds[0]].callMandatory;
                        if(mandatory) {
                            let qualiIds = [];
                            for(let j = 0; j < callQualiTypeIds.length; j++) {
                                let callQualiTypeId = callQualiTypeIds[j];
                                let qualiId = merchantQualiMap[callQualiTypeId].qualiId;
                                if(!Utils.isNoB(qualiId)) {
                                    qualiIds.push(qualiId);
                                }
                            }
                            if(qualiIds.length == 0) {
                                Toast.show('请选择组号为 "' + groupNo + '" 的对应任意资质', 3000, 'warning');
                                return false;
                            }
                        }
                    } else {
                        let qualiMerchant = merchantQualiMap[callQualiTypeIds[0]];
                        if(qualiMerchant.callMandatory) {
                            if(qualiMerchant.qualiId == null) {
                                Toast.show('请选择 "' + qualiMerchant.callQualiTypeName + '" 对应的资质', 3000, 'warning');
                                return false;
                            }
                        }
                    }
                }
                bidEnrollInfo.bidEnrollQualiList = merchantQualiList;   // 资质信息

                //检查附件
                let enrollFiles = self.enrollFiles || [];
                if(enrollFiles.length < 1) {
                    Toast.show('请选择 提供至少一个附件 ', 3000, 'warning');
                    return false;
                }
                bidEnrollInfo.bidEnrollFileList = enrollFiles;   // 附件信息
                //
                if(!self.agreeFlag) {
                    Toast.show("必须 同意 承诺 方可 保存", 3000, 'warning');
                    return false;
                }

                let postData = {};
                //
                postData.bidEnroll = bidEnrollInfo;
                // 是否在保存
                postData.saveFlag = true;
                //
                tendBidApi.saveBidEnroll(postData, function (result) {
                    if(result.type == 'info') {
                        // 跳转到报名列表
                        MsgBox.success("操作成功");
                        self.toBidEnrollList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toBidEnrollList: function () {
                this.$router.push({
                    path: SwbBidEnrollList.path
                });
            },
            goBack: function () {
                let hisUrl = this.$route.query.hisUrl;
                if(hisUrl == null) {
                    hisUrl = SwbBidEnrollList.path;
                }
                this.$router.push({
                    path: hisUrl
                });
            }
        }
    }

</script>

<style scoped>
    .selected {
        color: green;
    }

</style>



// WEBPACK FOOTER //
// src/compo/callbid/BidEnrollSignUp.vue